<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">{{label}}</v-card-title>

    <v-card-text>

        <div v-if="!has_descriptions">
            <v-select
                :label="label"
                :items="possible_values"
                v-model="value"
            />
        </div>

        <div v-else>
            <div class="mb-3">
                <strong>{{label}}</strong>
            </div>

            <v-radio-group v-model="value">
                <div
                    v-for="option in possible_values"
                    :key="option.value"
                    class="mb-4"
                >
                    <v-radio
                        :value="option.value"
                        :label="option.text"
                        class="mb-1"
                    />
                    <div
                        v-if="getDescription(option.value)"
                        class="ml-8 text-caption text--secondary"
                        style="margin-top: -8px;"
                    >
                        {{getDescription(option.value)}}
                    </div>
                </div>
            </v-radio-group>
        </div>

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const _ = require('lodash');

export default {

    props: {
        label: {
            type: String,
            default: function () { return ''; }
        },

        enum_name: {
            type: String,
            default: function() { return 'integration_name'; }
        },

        allow_any_enum_value: {
            type: Boolean,
            default: function() { return false; }
        },

        option_descriptions: {
            type: Object,
            default: function() { return null; }
        },
    },

    data() {
        return {
            dialog: false,
            value: null,
        }
    },

    methods: {
        showDialog(value)
        {
            this.value = value;
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok',this.value);
        },

        getDescription(option_value)
        {
            if (!this.option_descriptions) return null;
            return this.option_descriptions[option_value] || null;
        },
    },

    computed: {
        possible_values()
        {
            let ret = _.cloneDeep(this.$rc.enumChoices(this.enum_name));

            if ( !this.allow_any_enum_value )
            {
                ret.shift(); // remove the first value...
            }

            return ret;
        },

        has_descriptions()
        {
            return this.option_descriptions != null && Object.keys(this.option_descriptions).length > 0;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>